import { render, staticRenderFns } from "./DataTablePage.vue?vue&type=template&id=a5b29e04&"
import script from "./DataTablePage.vue?vue&type=script&lang=js&"
export * from "./DataTablePage.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports